module.exports = require("core-js/modules/esnext.set.every.js");